(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("g7Sp6", function(module, exports) {
var $bbd7804aa34cffdb$var$gallery = document.querySelectorAll(".s-faq, .s-gallery-intro");
$bbd7804aa34cffdb$var$gallery.forEach(function(section) {
    var gallerySlider = section.querySelector(".g-gallery-slider__large-img .g-gallery-slider");
    var gallerySlidersOverview = section.querySelector(".g-gallery-slider__wrapper .g-gallery-slider");
    if (!gallerySlider || !gallerySlidersOverview) return;
    var largeImages = section.querySelectorAll(".g-gallery-slider__large-img button");
    largeImages.forEach(function(img) {
        img.addEventListener("click", function() {
            var _a;
            var galleryLg = img.closest(".g-gallery-slider__large-img");
            var galleryLgActiveItem = img.closest(".swiper-slide");
            var gallery = (_a = galleryLg === null || galleryLg === void 0 ? void 0 : galleryLg.closest("section")) === null || _a === void 0 ? void 0 : _a.querySelector(".g-gallery-slider__wrapper .g-gallery-slider");
            if (!gallery) return;
            var galleryItems = Array.from(gallery === null || gallery === void 0 ? void 0 : gallery.querySelectorAll(".swiper-slide"));
            var selector = galleryLgActiveItem === null || galleryLgActiveItem === void 0 ? void 0 : galleryLgActiveItem.getAttribute("data-index");
            var slideActive = galleryItems[Number("".concat(selector))];
            var imgActive = slideActive.querySelector("a");
            imgActive === null || imgActive === void 0 || imgActive.click();
        });
    });
});

});

})();
//# sourceMappingURL=gallery-slider-group.78da85e4.js.map
